import { AssetAPI } from "../api";
export class Asset {
  constructor(props) {
    this.id = props.objectId || "";
    this.projectId = props.project.objectId || "";
    this.name = props.name || "";
    this.name_en = props.name_en || "";
    this.isRemoved = props.isRemoved || false;
    this.assetCategoryId = props.assetCategory.objectId || "";
    this.assetCategory = props.assetCategory || null;
  }
  get categoryName() {
    return (
      this.assetCategory?.name + " - " + this.assetCategory?.name_en || "-"
    );
  }
  static async getAsset(payload) {
    const { data } = await AssetAPI.getAsset(payload);
    const classesData = new Asset(data.result);
    return classesData;
  }
  static async getAssets(payload) {
    const { data } = await AssetAPI.getAssets(payload);
    const classesData = data.result.map(item => new Asset(item));
    return classesData;
  }
  static async updateAsset(payload) {
    const { data } = await AssetAPI.updateAsset(payload);
    const classesData = new Asset(data.result);
    return classesData;
  }
  static async removeAsset(payload) {
    const { data } = await AssetAPI.removeAsset(payload);
    const classesData = new Asset(data.result);
    return classesData;
  }
  static async createAsset(payload) {
    const { data } = await AssetAPI.createAsset(payload);
    const classesData = new Asset(data.result);
    return classesData;
  }
}
